/**
 * Import blocks
 */

import './_deprecated/header/index';

import './invoice/actions/index';
import './invoice/meta/index';
import './invoice/date/index';
import './invoice/duedate/index';
import './invoice/invoice-number/index';
import './invoice/paymentinformation/index';
import './invoice/table/index';

import './quote/actions/index';
import './quote/meta/index';
import './quote/date/index';
import './quote/information/index';
import './quote/table/index';
import './quote/validuntildate/index';

import './accounting/table/index';
import './accounting/actions/index';

import './settings/panel/index';
import './settings/theme-mod/index';
